import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { localizationSelector } from '~/App/shared/selectors/localization';
import { Locale } from '~/App/shared/localization/types';
import {
  buildLocaleUrl,
  getRedirectBaseUrl
} from '~/App/shared/localization/helpers';

export const useLanguageSelection = () => {
  const { domainLocale } = useSelector(localizationSelector);

  const getRedirectUrl = useCallback(
    (locale: Locale, generatedPath: string) => {
      const baseUrl = getRedirectBaseUrl({
        requestedlocale: locale,
        domainLocale,
        originUrl: window.location.origin
      });
      return buildLocaleUrl(baseUrl, locale, generatedPath);
    },
    [domainLocale]
  );

  return { getRedirectUrl };
};
